import { createReducer } from 'typesafe-actions';

import { AuthState, initialAuthState } from './types';

const authReducer = (initialState = initialAuthState) => {
  return createReducer<AuthState>(initialState);
};

export default authReducer;
